var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrapper p-0 m-0"},[_c('svg',{staticClass:"icon p-0 m-0",attrs:{"width":_vm.width,"height":_vm.height}},[(_vm.name != '')?_c('use',_vm._b({},'use',{ 'xlink:href': '/feather-sprite.svg#chevron-' + _vm.name },false)):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }